// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1CeBD","content":"Consent_content__33i5s","footer":"Consent_footer__41tgQ"};